
export const getStatusBadgeColor = (status: string) => {
  switch (status) {
    case 'pending':
      return 'bg-yellow-500 hover:bg-yellow-600';
    case 'in_progress':
      return 'bg-blue-500 hover:bg-blue-600';
    case 'resolved':
      return 'bg-green-500 hover:bg-green-600';
    case 'rejected':
      return 'bg-red-500 hover:bg-red-600';
    default:
      return 'bg-gray-500 hover:bg-gray-600';
  }
};

export const getTypeBadgeColor = (type: string) => {
  switch (type) {
    case 'bug_report':
      return 'bg-red-500';
    case 'feature_request':
      return 'bg-blue-500';
    case 'airport_request':
      return 'bg-purple-500';
    default:
      return 'bg-gray-500';
  }
};
